import { Flex, FlexProps } from '@chakra-ui/react'
import { useEffect, useRef } from 'react'

export interface OffersGridProps extends FlexProps {
  onIsScrolled?: (isScrolled: boolean) => void
}

export const OffersGrid = ({ children, sx, onIsScrolled, ...rest }: OffersGridProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = (event: Event) => {
      const scrollLeft = (event.target as HTMLDivElement).scrollLeft

      onIsScrolled && onIsScrolled(scrollLeft > 0)
    }

    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (ref.current) {
        ref?.current?.removeEventListener('scroll', handleScroll)
      }
    }
  }, [onIsScrolled])

  return (
    <Flex
      ref={ref}
      className="offers-grid"
      sx={{
        justifyContent: 'start',
        maxW: '100%',
        overflowY: 'auto',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Flex>
  )
}

OffersGrid.displayName = 'OffersGrid'
